import {Fragment} from "react";
import BasicSelect from "./BasicSelect";

export default function RelevanceLanguageSelect({name, label, placeholder, handleFormSelectChange, defaultValue, queryParam, input, meta}) {
    //@TODO: Create an endpoint to fetch these options (ISO 639-1 two-letter language code)
    const options = [
        {id: 'EN', name: 'English, (EN)'},
    ];

    return(
        <Fragment>
            <BasicSelect
                name={name}
                label={label}
                placeholder={placeholder}
                defaultValue={defaultValue}
                options={options}
                handleFormSelectChange={handleFormSelectChange}
                input={input}
                meta={meta} />
        </Fragment>
    )
}